'use client'

import { IconChatChatS } from 'icons/components/IconChatChatS'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { setToLocalStorage } from 'utils/webStorage/localStorage'
import { sendOpenChatbotEvent } from '../../../analytics/sendOpenChatbotEvent'
import {
	CHAT_ASSISTANT_ID,
	IS_CHAT_OPEN_KEY,
} from '../../../constants/constants'
import { dataTestIds } from '../../../constants/dataTestIds'
import { useChatbotDialog } from '../../../hooks/useChatbotDialog'
import styles from './ChatButton.module.scss'

const CHAT_ASSISTANT_ICON_SIZE = 20

export function ChatButton() {
	const { t } = useLabels()

	const {
		setIsDialogOpen,
		isDialogOpen,
		setIsDialogMinimized,
		isDialogMinimized,
	} = useChatbotDialog()

	const handleClick = () => {
		setIsDialogOpen(true)
		if (isDialogMinimized) {
			setIsDialogMinimized(false)
		}
		setToLocalStorage(IS_CHAT_OPEN_KEY, 'true')
		sendOpenChatbotEvent()
	}

	return isDialogOpen ? null : (
		<button
			id={CHAT_ASSISTANT_ID}
			data-testid={dataTestIds.chatbotButtonOpen}
			className={styles.chatAssistantButton}
			onClick={handleClick}
			type='button'
		>
			<IconChatChatS
				alt={t('accessibility.chatbot.icon')}
				height={CHAT_ASSISTANT_ICON_SIZE}
				width={CHAT_ASSISTANT_ICON_SIZE}
			/>
		</button>
	)
}
